import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '@app-core/services/data/data.service';
import { FormControl } from '@angular/forms';
import { Validators, FormBuilder } from '@angular/forms';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AccessService } from '@app-core/services/access/access.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EulaConsentService } from '@app-auth/services/eula-consent/eula-consent.service';
import { EULAConsentForm } from '@app-auth/common/eula-consent-form.model';

@Component({
  selector: 'app-eula',
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.scss'],
})
export class EulaComponent implements OnInit {
  public acceptAgreement = new FormControl(false);
  public step = 1;
  public consentForm: EULAConsentForm;
  public loader = false;
  private ngUnsubscribe = new Subject<void>();
  private loginInfo = this.accessService.getLoginInfo();
  public shouldSkipStep2: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EulaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { fleetId?: string },
    public dataService: DataService,
    private fb: FormBuilder,
    private accessService: AccessService,
    private eulaConsentService: EulaConsentService
  ) {}

  ngOnInit(): void {
    this.checkIfStep2ShouldBeSkipped();
    this.createForm();
  }

  private checkIfStep2ShouldBeSkipped(): void {
    this.shouldSkipStep2 = [
      'satrack',
      'satrackstaging', // for testing
    ].includes(this.loginInfo.customerName);
  }

  public viewAgreement() {
    this.step = 1;
  }

  public reject() {
    this.step = 0;
  }

  public next() {
    if (this.shouldSkipStep2) {
      this.confirm();
    } else {
      this.step = 2;
    }
  }

  public confirm() {
    if (this.consentForm.invalid) {
      return;
    }
    const body = {
      jobTitle: this.consentForm.value.jobTitle,
      organizationName: this.consentForm.value.organizationName,
    };

    this.loader = true;
    this.acceptAgreement.disable();

    this.eulaConsentService
      .saveEULAConsent(body, this.data.fleetId)
      .pipe(
        finalize(() => {
          this.loader = false;
          this.acceptAgreement.enable();
        }),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(
        (res) => {
          if (res?.data && res?.data?.EULAConsent === 'ACCEPTED') {
            this.dialogRef.close(true);
          } else {
            this.dialogRef.close(false);
          }
        },
        () => {
          this.dialogRef.close(false);
        }
      );
  }

  private createForm() {
    this.consentForm = this.fb.group({
      name: this.fb.control({ value: this.loginInfo['name'], disabled: true }),
      email: this.fb.control({ value: this.loginInfo['loginName'], disabled: true }),
      jobTitle: this.fb.control('', Validators.required),
      organizationName: this.fb.control('', Validators.required),
    });

    if (this.shouldSkipStep2) {
      const fleet = Array.isArray(this.loginInfo.fleets) ? this.loginInfo.fleets[0] : null;
      const jobTitle = fleet?.role?.roleName || '';
      const organizationName = fleet?.fleetId || '';

      this.consentForm.controls.jobTitle.setValue(jobTitle);
      this.consentForm.controls.organizationName.setValue(organizationName);

      this.consentForm.controls.jobTitle.disable();
      this.consentForm.controls.organizationName.disable();
    }
  }
}
